<template>
    <div class="tab-param">
       
    
        <center v-if="t9parm.length<=0&&Tab==0"><img src="@/assets/images/null.png"/></center>      
        <ul class="t9" v-show="Tab==0">
            <!-- t9parm: v2c输入参数 -->
          
            <li v-for="(item,i) in t9parm" :key="i+'v2c'" >

                <div class="t9_title">
                  
                    <div v-if="item.id" class="t9_title_top">
                        <i></i><span class="t9_title_title" style="overflow:hidden">{{item.describe}}</span>
                    </div>
                    <div class="showtag"> 
                     
                        <span class="range_show" v-if="(item.min instanceof Array)" :title="'MAX:'+item.max[0]+',MIN:'+item.min[0]+',VALUE:'+v2c[item.id]"><span class="range_value" :style="'width:'+(v2c[(item.id)]-item.min[0])/(item.max[0]-item.min[0]) * 100+'%'"></span></span>
                        <span class="range_show" v-else :title="'MAX:'+item.max+',MIN:'+item.min+',VALUE:'+v2c[item.id]"><span class="range_value" :style="'width:'+(v2c[item.id]-item.min)/(item.max-item.min) * 100+'%'"></span></span>
                        <!-- 模型参数列表 -->
                        <div class="tagbox">
                            <div class="out-column">+</div>
                  
                                <div class="tag" >
                                    <div class="tag_scroll">
                                       
                                    
                                        <div  class="tag_scroll_item" :class="{'disable':l2d.check==true}" v-for="(l2d,i) in l2dlist" :key="i+'l2d'" @click="checkParam(l2d,item)"> 
                                            <span :class="{'disable':l2d.check==true}">{{l2d.text?l2d.text:'自定义参数'}}</span>
                                            <span :class="{'disable':l2d.check==true}">  {{l2d.live2did}}</span> 
                                        </div>
                                    </div>
                                </div>
                        </div>
                        
                    </div>
                   
                    
                </div>
              
                   
                <!-- 当前绑定参数列表 输出参数 -->
                <div v-for="(t9l2d,i) in t9live2d" :key="i+'out'" >
                    
                    <div v-if="(t9l2d.t9id==item.id&&typeof t9l2d.live2did=='string')" class="out" :class="{'out_active':t9l2d.show}">
                      
                        <div class="out_item string_list" >
                          
                            <span :title="t9l2d.live2did">
                                【{{t9l2d.text?t9l2d.text:'自定义参数'}}】 ·  
                                <!-- <pre v-if="t9l2d.live2did=='ParamEyeRSmile'">{{v2cOutParam}}</pre> -->
                                          
                                <span v-if="v2cOutParam" class="range_show" :title="'VALUE:'+v2cOutParam[t9l2d.live2did]">
                                    <span class="range_value" :style="'width:'+(v2cOutParam[t9l2d.live2did]-item.min)/(item.max-item.min) * 100+'%'"></span>
                                </span>
                            
                            </span>
                  
   
                            <i class="iconfont icon-zhankai"  @click="showParam(t9l2d)"  :style="{'transform':t9l2d.show?'rotate(180deg)' :'rotate(0deg)'}"></i> 
                        </div>
                    
                        <div  v-if="t9l2d.show" class="out_param" >
                            <!-- <pre>{{item.min}}--{{item.max}}--{{t9l2d.range}}</pre> -->
                            <!-- <div class="flex" > <div class="left">阻力值</div> <vue。-slider v-model="t9l2d.resistance" :min="0" :max="100" @change="updateParam()" :process-style="{ backgroundColor: 'pink' }"   />   </div> -->
                            <div class="flex" > <div class="left">平滑度</div> <vue-slider v-model="t9l2d.fluency" :min="0" :max="100" @change="updateParam()" :process-style="{ backgroundColor: 'pink' }" /> 
                                <i v-tooltip="{content: '越小越平滑', color:'white', pos: 'top'}" class="iconfont icon-gantanhao icon-tooltip"></i>
                            </div>
                            <div class="flex" > <div class="left">取值区间</div>
                              
                                <vue-slider v-model="t9l2d.range" v-if="(item.min instanceof Array)" :min="item.min[0]" :max="item.max[0]" @change="getRange(t9l2d,$event,item)" :enable-cross="false" :process-style="{ backgroundColor: 'pink' }" />
                                <vue-slider v-model="t9l2d.range" v-else :min="item.min" :max="item.max" @change="getRange(t9l2d,$event,item)" :enable-cross="false" :process-style="{ backgroundColor: 'pink' }" />
                                <i v-tooltip="{content: '调整模型参数取值范围', color:'white', pos: 'top'}" class="iconfont icon-gantanhao icon-tooltip"></i>
                            </div>
                            
                            <div class="flex" ><div class="left"> <div >运动反向</div><toggle-switch :checked="t9l2d.relative" @change="switchRelative(t9l2d,$event)"></toggle-switch><i v-tooltip="{content: '运动反向', color:'white', pos: 'top'}" class="iconfont icon-gantanhao icon-tooltip"></i>  </div>  <i class="iconfont icon-remove-1-copy" @click="delParam(t9l2d.ids)"></i>   </div>
                        </div>
                     
                        
                    </div>


                    <!-- 输出参数数组类型 -->
                    <div v-if="t9l2d.t9id==item.id&&(t9l2d.live2did instanceof Array)" >
                        <div v-for="(t,i) in t9l2d.live2did" :key="i+'array'" class="out" :class="{'out_active':t9l2d.show}">

                            <div class="out_item"  >
                                    
                                    
                                    <span :title="t.live2did">【{{t.text?t.text:'自定义参数'}}】 · 
                                        
                                        <span v-if="v2cOutParam" :title="'VALUE:'+v2cOutParam[t.live2did]" class="range_show">
                                            
                                            <span class="range_value"  v-if="t.type=='Y'" :style="'width:'+(v2cOutParam[t.live2did]-item.min[0])/(item.max[0]-item.min[0]) * 100+'%'"></span>
                                            <span class="range_value"  v-else :style="'width:'+(v2cOutParam[t.live2did]-item.min[1])/(item.max[1]-item.min[1]) * 100+'%'"></span>
                                        </span>
                           

                                       
                                    </span>
                                    <i class="iconfont icon-zhankai"  @click="showParam(t)"  :style="{'transform':t.show?'rotate(180deg)' :'rotate(0deg)'}"></i> 
                            </div>
                        
                            <div class="out_param" v-if="t.show">
                                     
                                        
                                        <!-- <div class="flex" > <div class="left">阻力值</div> <vue-slider v-model="t.resistance" :min="0" :max="100" @change="updateParam()" :process-style="{ backgroundColor: 'pink' }" ></vue-slider> </div> -->
                                        <div class="flex" > <div class="left">平滑度</div> <vue-slider v-model="t.fluency" :min="0" :max="100" @change="updateParam()" :process-style="{ backgroundColor: 'pink' }" ></vue-slider> 
                                            <!-- <i v-tooltip="{content: '越小越平滑', color:'white', bgColor: 'black', pos: 'right'}" class="iconfont icon-gantanhao icon-tooltip"></i> -->
                                        </div>
                                        <div class="flex" > <div class="left">取值区间</div>
                                            <vue-slider v-model="t.range" v-if="t.type=='Y'" :min="item.min[0]" :max="item.max[0]" @change="getRange(t,$event,item)" :enable-cross="false" :process-style="{ backgroundColor: 'pink' }" ></vue-slider>
                                            <vue-slider v-model="t.range" v-if="t.type=='X'" :min="item.min[1]" :max="item.max[1]" @change="getRange(t,$event,item)" :enable-cross="false" :process-style="{ backgroundColor: 'pink' }" ></vue-slider>
                                    
                                         </div>
                                        <div class="flex" ><div class="left">  <div >运动反向</div><toggle-switch :checked="t.relative" @change="switchRelative(t,$event)"></toggle-switch> </div>  <i class="iconfont icon-remove-1-copy" @click="delParam(t.ids)"></i>  </div>
                                    </div>
                        

                        </div>
                        
                        
                    </div>
                  
                </div>
                
            </li>
        </ul>
        <div class="savebtn"  v-if="t9parm.length>0&&Tab==0"><span @click="resetT9l2dparam">恢复默认</span><span @click="cancel">取消修改</span> <span @click="saveParam" class="confirmbtn">保存参数</span> </div>
        
        

    </div>
  
</template>
<script>

import ToggleSwitch  from '@/components/v-switch/index.vue'
import {randomString} from '@/components/util/util_fun.js'
import VueSlider from 'vue-slider-component'
import {UserCommon} from '@/components/other/UserCommon.js'
import 'vue-slider-component/theme/antd.css'
export default {
    name: 'Param',
    props:['modelClass','v2cobj','v2cOutParam','user','defaultParam'],
     components:{
   
        ToggleSwitch,
        VueSlider
        // Tooltip
      
    },
    data(){
        return {
            Tab:0,
            l2dlist:[],//模型参数列表
            t9parm:[],// v2c输入参数
            t9live2d:[],//模型输出参数
            param:{},//当前角色参数
            v2c:{}//面捕返回的参数
            
            
        }
    },
    created(){
        // 获取t9默认参数
        var defaultParam=null;
       
        if(this.defaultParam&&this.defaultParam.t9live2d&&this.defaultParam.t9live2d.length>0){
             this.origin = JSON.parse(JSON.stringify(this.defaultParam));
             defaultParam = JSON.parse(JSON.stringify(this.defaultParam))
           
        }else {
       
            // 默认参数
            defaultParam = this.modelClass.getDefaultParam()
            this.origin = JSON.parse(JSON.stringify(defaultParam));
        }
       

    
   

        if(defaultParam.t9live2d==undefined) return;
      
        
        // v2c输入参数
        this.t9parm  = defaultParam.t9parm;
    
        // 参数的最小最大值为数组复数类型重新赋值
        this.t9parm.forEach(t=>{
          
            if(t.min instanceof Array){
                t.minY = t.min[1];
                t.maxY = t.max[1];
             
                t.minX = t.min[0];
                t.maxX = t.max[0];
                
            }
           
        })

        if(this.user.param!=""&&this.user.param!=undefined&&this.user.param!=null){
            this.param =  JSON.parse(this.user.param)
        }
     
        if(this.param.t9live2d&&this.param.t9live2d.length>0){
            this.t9live2d  = this.param.t9live2d;
            
        }else {
            // 输出参数更新参数
            this.t9live2d = JSON.parse(JSON.stringify(defaultParam.t9live2d))
            this.updateParam()
        }
        
        this.gett9Param()
    },
    
    methods:{
        
       
        // 获取输入参数
        gett9Param(){
            
     
            // 取值区间需数组类型(添加绑定取值范围） 参数框默认隐藏
            this.t9live2d.forEach(t=>{
                if(typeof t.live2did=='string'){
                    
                    if(t.Range_min){
                        t.range = [t.Range_min,t.Range_max];
                        // console.log('has:',t.live2did);
                    }else {
                        t.range = [t.min,t.max];
                        //  console.log('hnone:',t.live2did);
                    }
                   
                    t.ids='ids'+randomString(5);
                    if(this.t9parm[0].id!='breath'&&t.t9id=='breath'){
                    
                        var breath = {
                            "id":"breath",
                            "type":"number",
                            "min":t.min*100,
                            "max":t.max*100,
                            "normal":0,
                            "describe":"呼吸"
                            
                        }
                      
                        this.t9parm.unshift(breath)
                    }
                }else if(t.live2did instanceof Array) {
                  
                    // 默认的输出参数为多组数组单独处理一下(face) Y轴X轴 区分一下
                    t.live2did.forEach(arrt=>{
                        arrt.ids='ids'+randomString(5);
                        if(arrt.live2did.indexOf("Y")!=-1){
                            arrt.type='Y';
                        }else if(arrt.live2did.indexOf("X")!=-1){
                            arrt.type='X';
                        }
                       
                        if(arrt.Range_max){
                            arrt.range = [arrt.Range_min,arrt.Range_max];
                        }else {
                            arrt.range = [arrt.min,arrt.max];
                        }
                    })
                }

                t.show=false;
            })
           
            // 参数备份用于取消修改
            this.t9live2dBackups = JSON.parse(JSON.stringify(this.t9live2d));

            //获取模型参数(已绑定的参数禁用)
            var l2dlist =this.modelClass.getModelParam()

            var l2darr= [];
            // 输出参数去除掉模型不存在的参数
            l2dlist.forEach(t=>{
                l2darr.push(t.live2did)
            })
            this.t9live2d.forEach((t,i)=>{
                // 模型参数去掉已有的
                for (let l = 0; l < l2dlist.length; l++) {
                    if(t.live2did==l2dlist[l].live2did){
                        l2dlist[l].check=true;
                    }
                    if(typeof t.live2did!='string'){
                    
                        var arrL2d = t.live2did;
                        for(var m=0;m<arrL2d.length;m++){
                            if(arrL2d[m].live2did==l2dlist[l].live2did){
                                l2dlist[l].check=true;
                            }
                        }
                    }
                }
                // 输出参数去掉模型不存在的
                if((l2darr.indexOf(t.live2did) == -1)&&(typeof t.live2did=='string')){
                    this.t9live2d.splice(i,1)
                }
                if(typeof t.live2did!='string'){
                   
                    for (let a = 0; a < t.live2did.length; a++) {
                        if(l2darr.indexOf(t.live2did[a].live2did) == -1){
                            t.live2did.splice(a,1)
                        }
                    }
                }
            })
          
        
          
         
   
            this.l2dlist = l2dlist;
            // 参数备份
            this.l2dlistBackups =JSON.parse(JSON.stringify(l2dlist));
        },
        
        // 添加参数
        checkParam(param,t9param){
            // param模型参数 t9param v2c参数
           
            console.log(t9param);
            // 必须与Parm_l2d.config中t9live2d同类型参数格式一致否则绑定错误
            var obj = {}
            if(t9param.min instanceof Array){
                obj.live2did = [];
                obj.t9id=t9param.id;
                var live2dObj = {
                    
                    "fluency":param.fluent,
                    "live2did":param.live2did,
                    "relative":false,
                    "Range_max":param.max,
                    "Range_min":param.min,
                    "max":param.max,
                    "min":param.min,
                    "resistance":0,
                    "text":param.text
                }

              
                if(param.max>t9param.max){
                    live2dObj.Range_max = t9param.max;
                }else if(param.min<t9param.min){
                    live2dObj.Range_min = t9param.min;
                }




                live2dObj.range= [live2dObj.Range_min,live2dObj.Range_max],
                obj.live2did.push(live2dObj)
            }else {
                obj ={
                    "t9id":t9param.id,
                    "live2did":param.live2did,
                    "fluency":param.fluent,
                    "relative":false,
                    "Range_max":param.max,
                    "Range_min":param.min,
                    "max":param.max,
                    "min":param.min,
                    "resistance":0,
                    "text":param.text
                }
           
                // 默认先取模型默认最大最小值 超出重新赋值
                if(param.max>t9param.max){
                    obj.Range_max = t9param.max;
                }else if(param.min<t9param.min){
                    obj.Range_min = t9param.min;
                }
                obj.range=[obj.Range_min,obj.Range_max];
             
            }
          
            if((t9param.min instanceof Array)&&(t9param.min[0]<param.min||t9param.max[0]<param.max)){
         
                  obj.range = [t9param.min[0],t9param.max[0]];
                  obj.Range_max = t9param.max[0];
                  obj.Range_min = t9param.min[0];
            }
            // console.log(obj);
            this.t9live2d.push(obj)
          
         
            
            // 修改对应模型参数状态
            param.check=true;
            this.updateParam()
        
        },
        // 删除参数
        delParam(ids){
              this.$confirm({
                 title: "操作提示",
                  type: "warning",
                message: '确定要删除该参数吗？'
            })
            .then(() => {
               
                 this.t9live2d.forEach((item,i)=>{
                    
                    if(item.live2did&&typeof item.live2did=='string'&&item.ids==ids){
                       
                        this.t9live2d.splice(i, 1)
                        this.l2dChange(item.live2did)
                       
                    }else if(item.live2did instanceof Array) {
                    
                        // 多个参数
                        item.live2did.forEach((arrt,a)=>{
                           
                            if(arrt.ids==ids){
                             
                                this.t9live2d[i].live2did.splice(a, 1)
                                this.l2dChange(arrt.live2did)
                            }
                        })
      
                    }
                })
                this.updateParam()
            })
            .catch(() => {
                that.loading = false;
            });
            // this.$fire({
            //     title: "操作提示",
            //     text: "确定要删除该参数吗？",
            //     type: "warning",
            // }).then(r => {
            //     this.t9live2d.forEach((item,i)=>{
                    
            //         if(item.live2did&&typeof item.live2did=='string'&&item.ids==ids){
                       
            //             this.t9live2d.splice(i, 1)
            //             this.l2dChange(item.live2did)
                       
            //         }else if(item.live2did instanceof Array) {
                    
            //             // 多个参数
            //             item.live2did.forEach((arrt,a)=>{
                           
            //                 if(arrt.ids==ids){
                             
            //                     this.t9live2d[i].live2did.splice(a, 1)
            //                     this.l2dChange(arrt.live2did)
            //                 }
            //             })
      
            //         }
            //     })
            //     this.updateParam()
            // })
            
           
        },
        // 浮动框模型参数选中状态改变
        l2dChange(l2d){
            for (let l = 0; l < this.l2dlist.length; l++) {
                if(l2d==this.l2dlist[l].live2did){
                    this.l2dlist[l].check=false;
                }
                
            }
        },
        // 显示参数详情
        showParam(t9l2d){
            t9l2d.show=!t9l2d.show;
            this.$forceUpdate()
           
        },
        // 修改取值范围
        getRange(val,event,item){
            
            this.t9live2d.forEach(t=>{
                // 单数
                if(t.t9id==val.t9id){
                    t.Range_max = val.range[1]
                    t.Range_min = val.range[0]

                    if(t.t9id=='breath'){
                        t.Range_min = val.range[0]/100
                        t.Range_max = val.range[1]/100
                    }
                }else if(val.type&& t.t9id ==item.id) {
                    // 复数判断
                    t.live2did.forEach(arrt => {
                        if(arrt.live2did== val.live2did){
                            arrt.Range_min = val.range[0];
                            arrt.Range_max = val.range[1]

                        }
                     
                    });
                    
                }
                
            })
  
            this.updateParam()
            
        },
        // 修改反向值
        switchRelative(val,data){
            
            if(typeof(data)=="boolean"){
                val.relative = data
                this.updateParam()
               
            }
        },
        // 更新参数到t9model
        updateParam(){
            
            if(this.param.t9live2d&&this.param.t9live2d.length>0){
                this.param.t9live2d = this.t9live2d;
            }
            this.modelClass.updatet9db(this.t9live2d);
           
        },
        // 取消报存
        cancel(){
            
            this.t9live2d = JSON.parse(JSON.stringify(this.t9live2dBackups));
            this.l2dlist = JSON.parse(JSON.stringify(this.l2dlistBackups));
            this.updateParam()
            this.$message.success({ title:"已取消修改!", collapsable:false,position:"bottom-center" })

        },
        // 重置功能设为初始值
        resetT9l2dparam(){
            
            this.t9live2d = JSON.parse(JSON.stringify(this.origin.t9live2d));
            this.t9parm = JSON.parse(JSON.stringify(this.origin.t9parm));
            this.updateParam();
            this.gett9Param(); 
            this.$message.success({title:"已重置默认值!",collapsable:false,position:"bottom-center"})
          

        },
        // 保存参数
        async saveParam(){
        
            this.param.t9live2d = this.t9live2d;
            this.user.param = JSON.stringify(this.param)
            this.user.uid=this.$store.state.userinfo.userId;
            UserCommon.saveUser(this.user,true)
        },
     
      
    },
    watch: { 
        
        v2cOutParam:{
            deep: true,  
            handler(newVal, oldVal) {
                // console.log(newVal)
             
            }
        },
        v2cobj: {
        deep: true,   //深度监听（用在监听对象属性的改变）
            handler(newVal, oldVal) {
                // 数组类型(返回string右侧框数据处理取出最小值)
                this.v2c = JSON.parse(JSON.stringify(newVal))
                for (let key  in  this.v2c) {
                  
                    // if(key=='eyebrow_width'){
                    //     console.log(this.v2c[key]);
                    // }
                    if(this.v2c[key] instanceof Array){
                        this.v2c[key] = this.v2c[key][0];
                    }
                }
             
            }
        }
    },

}
</script>
